import i18next from "i18next";
import React from "react";
import { Chip, Box } from "@mui/material";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { isMobile } from "react-device-detect";
import { styled } from "@mui/material/styles";
import { tr, enUS, ru, ro, th } from "date-fns/locale";

const JSZip = require("jszip");

export const handleBackendMessage = (message) => {
    const t = i18next.t.bind(i18next);
    if (message.response) {
        if (message.response.data.message && message.response.data.message.value) {
            return message.response.data.message.value;
        }

        if (message.response.data) {
            return message.response.data.message;
        }
    }
    if (message.data) {
        return message.data.message;
    }
    if (message) {
        return message;
    } else if (message.message) {
        return message.message;
    } else {
        if (message.data != undefined || message.data != null) {
            return message.data.message.value;
        }
    }

    return <div> {t("GeneralErrorMessage")}</div>;
};

export const handleBackendErrorCode = (message) => {
    if (message.response) {
        return message.response.status;
    }
    return 500;
};

export const renderToaster = (enqueueSnackbar, message, severity) => {
    const t = i18next.t.bind(i18next);
    try {
        const errorArray = message.split("\n");
        errorArray.forEach((element) => {
            if (element != "") {
                enqueueSnackbar(element, {
                    variant: severity,
                    autoHideDuration: severity == "error" ? 4000 : 2000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    sx: { marginTop: 5 },
                });
            }
        });
    } catch (error) {
        enqueueSnackbar(<div> {t("GeneralErrorMessage")}</div>, {
            variant: severity,
            autoHideDuration: 4000,
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

let sortOrder = "";
let sortColumn = "";
export const commonSort = (row, column) => {
    if (column === sortColumn) {
        sortOrder = -sortOrder;
    } else {
        sortOrder = 1;
    }
    sortColumn = column;

    let filteredItems = row.sort(function (a, b) {
        if (a[sortColumn] === b[sortColumn]) {
            return 0;
        } else if (a[sortColumn] === null) {
            return 1;
        } else if (b[sortColumn] === null) {
            return -1;
        } else if (sortOrder == 1) {
            return a[sortColumn] < b[sortColumn] ? -1 : 1;
        } else {
            return a[sortColumn] < b[sortColumn] ? 1 : -1;
        }
    });
    return [sortOrder, sortColumn, filteredItems];
};

export const qrScroll = (qrRef, executedScroll) => {
    if (!executedScroll) {
        qrRef.current.scrollIntoView({ behavior: "smooth" });
        return true;
    }
};

export const GetValidPlannedDates = (taskDays) => {
    let validDates = [];
    if (taskDays.length > 0) {
        for (let day of taskDays) {
            if (moment(day).format("YYYY-MM-DD") >= moment(new Date()).format("YYYY-MM-DD")) {
                validDates.push(day);
            }
        }
    }
    return validDates;
};

export const convertedColumnName = (columnName) => {
    console.log(columnName);
    var columnDict = {
        id: "Id",
        statusDesc: "TaskStatus",
        breakdownEffectName: "BreakdownEffectName",
        createdDate: "CreatedDate",
        mainEquipmentCode: "MainEquipmentCode",
        equipmentName: "EquipmentName",
        orderNote: "OrderNote",
        notes: "Notes",
        assigneeName: "AssigneeName",
        totalPausedMin: "TotalPausedMin",
        totalDurationMin: "TotalDurationMin",
        poolName: "PoolName",
        priority: "Priority",
        breakdownReasonGroupName: "BreakdownReasonGroupName",
        breakdownRootCauseName: "BreakdownRootCauseName",
        breakdownReasonPlaceName: "BreakdownReasonPlaceName",
        breakdownReasonDetailName: "BreakdownReasonDetailName",
        completedDate: "CompletedDate",
        creatorName: "CreatorName",
        creatorCode: "CreatorCode",
        assigneeDurationMin: "AssigneeDurationMin",
        startDurationMin: "StartDurationMin",
        equipmentCode: "EquipmentCode",
        costCenterCode: "CostCenterCode",
        plannedPersonCount: "PlannedPersonCount",
        plannedHoursPerPerson: "PlannedHoursPerPerson",
        maintenanceOrderId: "MaintenanceOrderId",
        mesCode: "MesCode",
        freeText1: "FreeText1",
        freeText2: "FreeText2",
        freeText3: "FreeText3",
        freeText4: "FreeText4",
        isEnvNotClean: "IsEnvNotClean",
        userName: "UserName",
        totalTaskCount: "TotalTaskCount",
        averageStartingTime: "AverageStartingTime",
        averageCompletionTime: "AverageCompletionTime",
        mttr: "MTTR",
    };

    return columnDict[columnName[0].field];
};

export const handleStatusName = (rawArray, filterArray) => {
    const statusFiltered = rawArray.filter((el) => {
        return filterArray.some((f) => {
            return f === el.code;
        });
    });
    return statusFiltered.map((item) => item.description);
};

export const flattenObject = (obj, parentKey = "") => {
    const result = {};

    for (const key in obj) {
        const newKey = parentKey ? `${parentKey}.${key}` : key;

        if (typeof obj[key] === "object" && obj[key] !== null) {
            Object.assign(result, flattenObject(obj[key], newKey));
        } else {
            result[newKey] = obj[key];
        }
    }

    return result;
};

export const flattenDataMethod = (rows) => {
    const flattenDataArray = [];
    rows.forEach((obj) => {
        const flattenedData = flattenObject(obj);
        flattenDataArray.push({ ...flattenedData });
    });
    return flattenDataArray;
};

export const getTableColumns = (isPlanned) => {
    const t = i18next.t.bind(i18next);
    const commonColumns = [
        {
            headerName: t("TaskNo"), //pt
            field: "id",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Status"),
            field: "statusDesc",
            valueFormatter: (params) => {
                return t(params.value);
            },
            minWidth: 150,
            flex: 1,
            type: "singleSelect",
        },
        {
            headerName: t("MainEquipmentCode"), //ortak
            field: "mainEquipmentCode",
            filterable: false,
            minWidth: 250,
            flex: 1,
        },
        {
            headerName: t("EquipmentCode"),
            field: "equipmentCode",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("EquipmentName"),
            field: "equipmentName",
            filterable: false,
            minWidth: 250,
            flex: 1,
        },
        {
            headerName: t("CostCenter"),
            field: "costCenterCode",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Pool"),
            field: "poolName",
            minWidth: 200,
            flex: 1,
            type: "singleSelect",
        },
        {
            headerName: t("Assigned"),
            field: "assigneeName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("WorkingPersonCount"),
            field: "technicianCount",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Creator"), //ortak
            field: "creatorCode",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Declarative"),
            field: "creatorName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("MesCode"),
            field: "mesCode",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("WorkingNote"),
            field: "notes",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("Priority"), //pt
            field: "priority",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("AssignmentDuration"), //ortak
            field: "assigneeDurationMin",
            filterable: false,
            valueFormatter: (params) => {
                return Math.round(params.value);
            },
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("StartTime"),
            field: "startDurationMin",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("CompletionTime"),
            field: "completedDate",
            filterable: false,
            valueFormatter: (params) => {
                return params.value === "0001-01-01T00:00:00" ? "" : moment.parseZone(params.value).format("DD.MM.YYYY HH:mm");
            },
            minWidth: 170,
            flex: 1,
        },
        {
            headerName: t("TotalTimeMin"),
            field: "totalDurationMin",
            filterable: false,
            valueFormatter: (params) => {
                return Math.round(params.value);
            },
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("FreeText") + " 1",
            field: "freeText1",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("FreeText") + " 2",
            field: "freeText2",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("FreeText") + " 3",
            field: "freeText3",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("FreeText") + " 4",
            field: "freeText4",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("EkedStatus"),
            field: "isEkedUsed",
            renderCell: (params) => {
                return params.value === true ? <Chip color="success" label={t("EkedIsUsing")}></Chip> : <Chip color="error" label={t("EkedIsNotUsing")}></Chip>;
            },
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("OrderFormStatus"),
            field: "hasOrderPlaced",
            renderCell: (params) => {
                return params.value === true ? <Chip color="success" label={t("OrderFormUsed")}></Chip> : <Chip color="error" label={t("OrderFormNotUsed")}></Chip>;
            },
            minWidth: 250,
            flex: 1,
        },
        {
            headerName: t("EnvironmentalCompliance"),
            field: "isEnvNotClean",
            renderCell: (params) => {
                return params.value === true ? <Chip color="error" label={t("NotCleanEnvironment")}></Chip> : <Chip color="success" label={t("CleanEnvironment")}></Chip>;
            },
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("AssignedDate"), //ortak
            filterable: true,
            field: "assignedDate",
            renderCell: (params) => {
                const duration = Math.round(params.row.assigneeDurationMin); // diğer kolona erişim
                const createdDate = params.row.createdDate === "0001-01-01T00:00:00"
                    ? null
                    : moment.parseZone(params.row.createdDate); // createdDate'i moment formatında al

                if (createdDate) {
                    // Duration değerini createdDate'in üzerine ekleyip yeni tarihi hesapla
                    const updatedDate = createdDate.add(duration, 'minutes').format("DD.MM.YYYY HH:mm");
                    return `${updatedDate}`; // Güncellenmiş tarihi göster
                }

                return `${duration} min`; // Eğer createdDate yoksa sadece duration'u göster
            },
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("StartDate"),
            field: "startDate",
            filterable: false,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MM-YYYY HH:mm");
            },
            minWidth: 200,
            flex: 1,
        }
    ];
    const onlyBreakdownColumns = [
        {
            headerName: t("CallNumber"),
            field: "maintenanceOrderId",
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("CreatedDate"),
            field: "createdDate",
            filterable: false,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MM-YYYY HH:mm");
            },
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("Shift"),
            field: "startedShift",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Effect"),
            field: "breakdownEffectName",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("BreakdownGroup"),
            field: "breakdownReasonGroupName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("Area"),
            field: "areaName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("BreakdownPlace"),
            field: "breakdownTaskPlaceName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("BreakdownDetail"),
            field: "breakdownReasonDetailName",
            filterable: false,
            minWidth: 170,
            flex: 1,
        },
        {
            headerName: t("BreakdownRootCause"),
            field: "breakdownRootCauseName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("CallNote"),
            field: "orderNote",
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("TotalPausedMin"), //ortak //performansta sıkıntı olursa kalabilir.
            field: "totalPausedMin",
            filterable: false,
            valueFormatter: (params) => {
                return Math.round(params.value);
            },
            minWidth: 120,
            flex: 1,
        }

    ];

    const onlyPlannedColumns = [
        {
            headerName: t("PlanNo"),
            field: "maintenanceOrderId",
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("MaintenanceType"),
            field: "maintenanceTypeName",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("MaintenanceNote"), //pt
            field: "orderNote",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("PlannedDate"),
            field: "plannedDate",
            filterable: false,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MM-YYYY HH:mm");
            },
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("Shift"),
            field: "shiftNo",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("StartedShift"),
            field: "startedShift",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("PlannedPersonCount"),
            field: "plannedPersonCount",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Person/Hour"),
            field: "plannedHoursPerPerson",
            filterable: false,
            minWidth: 100,
            flex: 1,
        },
    ];

    return commonColumns.concat(isPlanned ? onlyPlannedColumns : onlyBreakdownColumns);
};

export const getEwoFormColumns = () => {
    const t = i18next.t.bind(i18next);

    const columns = [
        {
            headerName: t("ID"), //pt
            field: "id",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("EwoCode"), //pt
            field: "ewoCode",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("MainEquipment"), //pt
            field: "mainEquipmentName",
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("EquipmentName"), //pt
            field: "equipmentName",
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("CreatedDate"), //pt
            field: "date",
            valueFormatter: (params) => {
                return moment(params.value).subtract(3, 'h').format("DD-MM-YYYY");
            },
            minWidth: 150,
            flex: 1,
        },

        {
            headerName: t("TimeBreakdownOccured"), //pt
            field: "recordOfIntervention.timeBreakdownOccured",
            minWidth: 200,
            valueFormatter: (params) => {
                return moment(params.value).subtract(3, 'h').format("DD-MM-YYYY HH:mm");
            },
            flex: 1,
        },
        {
            headerName: t("InterventionEndedDate"), //pt
            field: "recordOfIntervention.interventionEnded",
            minWidth: 200,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MM-YYYY HH:mm");
            },
            flex: 1,
        },
        {
            headerName: t("Wait(min)"), //pt
            field: "recordOfIntervention.wait",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("Diagnosis"), //pt
            field: "recordOfIntervention.diagnosis",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("SparePartSearch(min)"), //pt
            field: "recordOfIntervention.sparePartSearch",
            minWidth: 133,
            flex: 1,
        },
        {
            headerName: t("Repairing(min)"), //pt
            field: "recordOfIntervention.repairing",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("StartUp(min)"), //pt
            field: "recordOfIntervention.startUp",
            minWidth: 100,
            flex: 1,
        },
        {
            headerName: t("BreakdownGroup"), //pt
            field: "recordOfIntervention.breakdownGroupName",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("RootCauseFamily"), //pt
            field: "rootCausesFamilyDetail.rootCausesFamilyName",
            minWidth: 300,
            flex: 1,
        },
        {
            headerName: t("RootCauseOption"), //pt
            field: "rootCausesFamilyDetail.rootCusesFamilyOptionName",
            minWidth: 300,
            flex: 1,
        },
        {
            headerName: t("AnalysisExecutedBy"), //pt
            field: "analysisExecutedByName",
            minWidth: 300,
            flex: 1,
        },
        {
            headerName: t("VerifiedBy"), //pt
            field: "verifierByName",
            minWidth: 300,
            flex: 1,
        },
        {
            headerName: t("ClosureDate"), //pt
            field: "closureDate",
            minWidth: 200,
            valueFormatter: (params) => {
                return moment(params.value).subtract(3, 'h').format("DD-MM-YYYY");
            },
            flex: 1,
        },
    ];

    return columns;
};

export const GetBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.toString());
        reader.onerror = (error) => reject(error);
    });
};

export function base64toBlob(base64Data, contentType) {
    contentType = contentType || "";
    const sliceSize = 1024;
    const byteCharacters = Buffer.from(base64Data, "base64");
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

export async function getFilesFromZip(zipFile) {
    const newZip = new JSZip();
    let files = [];

    const zip = await newZip.loadAsync(zipFile);
    for (const fileName in zip.files) {
        const fileData = await zip.file(fileName).async("blob");
        files.push({
            name: fileName,
            blob: fileData,
        });
    }

    return files;
}

export const getSelectedFileNames = (selectedFiles) => {
    const selectedFileNames = [];
    selectedFiles.forEach((file) => {
        if (file.checked) {
            selectedFileNames.push(file.name);
        }
    });

    return selectedFileNames;
};

export const getFormDataFromFiles = (files) => {
    let formData = new FormData();
    for (const file of files) {
        formData.append("files", file, file.name);
    }

    return formData;
};

export const getPersonnelSummaryColumns = () => {
    const t = i18next.t.bind(i18next);

    return [
        {
            headerName: t("UserName"),
            field: "userName",
            minWidth: 150,
            flex: 1,
            cellClassName: "default-row-color",
        },
        {
            headerName: t("TotalTaskCount"),
            field: "totalTaskCount",
            minWidth: 250,
            flex: 1,
            cellClassName: "default-row-color",
        },
        {
            headerName: t("AverageStartingTime"),
            field: "totalAvgStartDuration",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "default-row-color",
        },
        {
            headerName: t("AverageCompletionTime"),
            field: "totalAvgMaintDuration",

            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "default-row-color",
        },
        {
            headerName: t("PlannedTotalTaskCount"),
            field: "plannedTaskCount",
            minWidth: 250,
            flex: 1,
            cellClassName: "planned-row-color",
        },
        {
            headerName: t("PlannedAverageStartingTime"),
            field: "plannedAvgStartDuration",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "planned-row-color",
        },
        {
            headerName: t("PlannedAverageCompletionTime"),
            field: "plannedAvgMaintDuration",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "planned-row-color",
        },
        {
            headerName: t("UnPlannedTotalTaskCount"),
            field: "unPlannedTaskCount",
            minWidth: 250,
            flex: 1,
            cellClassName: "unPlanned-row-color",
        },
        {
            headerName: t("UnPlannedAverageStartingTime"),
            field: "unPlannedAvgStartDuration",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "unPlanned-row-color",
        },
        {
            headerName: t("UnPlannedAverageCompletionTime"),
            field: "unPlannedAvgMaintDuration",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "unPlanned-row-color",
        },
        {
            headerName: t("UnPlannedMTTR"),
            field: "mttr",
            valueFormatter: (params) => {
                return (Math.round(params.value * 100) / 100).toFixed(1);
            },
            minWidth: 250,
            flex: 1,
            cellClassName: "unPlanned-row-color",
        },
    ];
};

export const getSparePartColumns = () => {
    const t = i18next.t.bind(i18next);

    return [
        {
            field: "materialCode",
            headerName: t("StockNo"),
            width: 150,
        },
        {
            field: "materialDescription",
            headerName: t("MaterialDescription"),
            width: 350,
        },
        {
            field: "shelfNo",
            headerName: t("ShelfNo"),
            width: 80,
        },
        {
            field: "unit",
            headerName: t("Unit"),
            width: 80,
        },
        {
            field: "stockQuantity",
            headerName: t("WareHouseQuantity"),
            width: 120,
        },
        {
            field: "department",
            headerName: t("Department"),
            width: 110,
        },
        {
            field: "description",
            headerName: t("Description"),
            width: 500,
        },
    ];
};

export const getSparePartListColumns = () => {
    const t = i18next.t.bind(i18next);

    const columns = [
        {
            headerName: t("TaskNo"),
            field: "taskId",
            minWidth: 90,
            flex: 1,
        },
        {
            headerName: t("MainEquipmentCode"), //ortak
            field: "mainEquipmentCode",
            filterable: false,
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("EquipmentCode"),
            field: "equipmentCode",
            filterable: false,
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("EquipmentName"),
            field: "equipmentName",
            filterable: false,
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("CostCenter"),
            field: "costCenterName",
            filterable: false,
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: t("StockNo"),
            field: "sparePartMaterialCode",
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("MaterialDescription"),
            field: "sparePartMaterialDescription",
            minWidth: 250,
            flex: 1,
        },
        {
            headerName: t("SparePartQuantity"),
            field: "sparePartUsageAmount",
            minWidth: 80,
            flex: 1,
        },
        {
            headerName: t("Unit"),
            field: "sparePartUnit",
            minWidth: 80,
            flex: 1,
        },
        {
            headerName: t("Pool"),
            field: "poolName",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: t("Assigned"),
            field: "taskAssigneeName",
            filterable: false,
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("CreatedDate"),
            field: "taskCreatedDate",
            filterable: false,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MM-YYYY HH:mm");
            },
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("CompletionTime"),
            field: "taskCompletedDate",
            filterable: false,
            valueFormatter: (params) => {
                return params.value === "0001-01-01T00:00:00" ? "" : moment.parseZone(params.value).format("DD.MM.YYYY HH:mm");
            },
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: t("SparePartUsageDate"),
            field: "sparePartUsageDate",
            filterable: false,
            valueFormatter: (params) => {
                return params.value === "0001-01-01T00:00:00" ? "" : moment.parseZone(params.value).format("DD.MM.YYYY HH:mm");
            },
            minWidth: 170,
            flex: 1,
        },
    ];
    return columns;
};
export const getTitle = (title) => {
    if (isMobile) {
        return <h4>{title}</h4>;
    } else {
        return <h1>{title}</h1>;
    }
};

export const noRowsTemplate = () => {
    const t = i18next.t.bind(i18next);
    const StyledGridOverlay = styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        "& .ant-empty-img-1": {
            fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
        },
        "& .ant-empty-img-2": {
            fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
        },
        "& .ant-empty-img-3": {
            fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
        },
        "& .ant-empty-img-4": {
            fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
        },
        "& .ant-empty-img-5": {
            fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
            fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
        },
    }));

    return (
        <StyledGridOverlay>
            <svg width="120" height="100" viewBox="0 0 184 152" aria-hidden focusable="false">
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(24 31.67)">
                        <ellipse className="ant-empty-img-5" cx="67.797" cy="106.89" rx="67.797" ry="12.668" />
                        <path
                            className="ant-empty-img-1"
                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        />
                        <path className="ant-empty-img-2" d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" />
                        <path
                            className="ant-empty-img-3"
                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        />
                    </g>
                    <path
                        className="ant-empty-img-3"
                        d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                    />
                    <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                        <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                        <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                    </g>
                </g>
            </svg>
            <Box sx={{ mt: 1 }}>{t("NoResult")}</Box>
        </StyledGridOverlay>
    );
};

export const getLocalLanguage = () => {
    let language = enUS;
    if (localStorage.getItem("i18nextLng") === "tr-TR") {
        return (language = tr);
    } else if (localStorage.getItem("i18nextLng") === "ru-RU") {
        return (language = ru);
    } else if (localStorage.getItem("i18nextLng") === "ro-RO") {
        return (language = ro);
    } else if (localStorage.getItem("i18nextLng") === "th-TH") {
        return (language = th);
    }
};
